import React from 'react';
import ReactDOM from 'react-dom';
import Context from './Context';
import App from './App';

const $root = document.getElementById('root')

switch (window.location.hostname) {
  case process?.env?.REACT_APP_THEME_CUOTITAS_HOST: $root.setAttribute('theme', 'cuotitas'); break
  case process?.env?.REACT_APP_THEME_CUOTAYA_HOST: $root.setAttribute('theme', 'cuota-ya'); break
  case process?.env?.REACT_APP_THEME_DEMO_HOST: $root.setAttribute('theme', 'demo'); break
  default: $root.setAttribute('theme', 'demo'); break;
}

const params = new URL(document.location).searchParams;

if(params.has('theme') && ['cuotitas', 'cuota-ya', 'demo'].includes(params.get('theme'))) {
  $root.setAttribute('theme', params.get('theme'))
}

ReactDOM.render(
  <React.StrictMode>
    <Context>
      <App />
    </Context>
  </React.StrictMode>,
  $root
);
